import { useUISettings } from 'dashboard/composables/useUISettings';

const FIXED_AT_END = 'Settings';

export function useSidebarItemsOrder() {
  const { uiSettings, updateUISettings } = useUISettings();

  const reorderItems = allItems => {
    const fixedItem = allItems.find(i => i.name === FIXED_AT_END);
    const reorderable = allItems.filter(i => i.name !== FIXED_AT_END);

    const savedOrder = uiSettings.value.sidebar_items_order;
    if (!savedOrder) return { reorderable, fixedItem };

    const byName = new Map(reorderable.map(i => [i.name, i]));
    const ordered = [];
    savedOrder.forEach(name => {
      if (byName.has(name)) {
        ordered.push(byName.get(name));
        byName.delete(name);
      }
    });
    reorderable.forEach(i => {
      if (byName.has(i.name)) ordered.push(i);
    });

    return { reorderable: ordered, fixedItem };
  };

  const saveOrder = newReorderable => {
    updateUISettings({
      sidebar_items_order: newReorderable.map(i => i.name),
    });
  };

  return { reorderItems, saveOrder };
}
